<div class="the_container">
  @if(!isMobileDevice){
  <div (clicked)="(true)" class="topNavigation d-flex justify-content-between">
    <span>Work History</span>
  </div>
  }
  <app-dp-tab-menu-v3></app-dp-tab-menu-v3>
  <router-outlet></router-outlet>
</div>
